import { render, staticRenderFns } from "./GoodstypeManage.vue?vue&type=template&id=35eff010&scoped=true&"
import script from "./GoodstypeManage.vue?vue&type=script&lang=js&"
export * from "./GoodstypeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eff010",
  null
  
)

export default component.exports